import { Box, Button, Flex, Heading, HStack, Text } from '@chakra-ui/react';
import { useNavigate } from 'react-router-dom';
import { TrainingContainer } from '../components/LandingPageComponents/styles/SplashStyles';
import { useScreenWidth } from 'hooks/useScreenWidth';

const DesktopTraining = () => {
    const navigate = useNavigate();
    const screen = useScreenWidth();

    return (
        <TrainingContainer>
            <HStack justify="end" px="17px" alignItems="center">
                <Text
                    color="#979C9E"
                    fontSize="18px"
                    display={{ base: 'flex', lg: 'none' }}
                    lineHeight="18px">
                    Skip
                </Text>
            </HStack>
            <Flex w="full" h="full" justify="center" alignItems="center" flexDir="column">
                <Box w="70%">
                    <Text
                        color="#090A0A"
                        mt="0"
                        textAlign="center"
                        fontSize="24px"
                        lineHeight="16px">
                        Obana Certification
                    </Text>
                    <Heading
                        as="h2"
                        mt="25px"
                        mb="26px"
                        w="40%"
                        mx="auto"
                        color="#090A0A"
                        textAlign="center"
                        fontSize="32px"
                        lineHeight="36px">
                        Let’s Start Your Training{' '}
                    </Heading>
                </Box>
                <Box className="training-img" w="780px" h="430px" pos="relative">
                    <Flex
                        position="absolute"
                        bottom="-4rem"
                        gap="1rem"
                        justifyContent="center"
                        left="30%"
                        w="40%">
                        <Button
                            mb="5.5rem"
                            w="200px"
                            mx="auto"
                            fontWeight="400"
                            borderRadius="48px"
                            color="#090A0A"
                            fontSize="16px"
                            // onClick={() =>
                            //     navigate(
                            //         screen > 500
                            //             ? '/dashboard/complete-training'
                            //             : '/complete-training',
                            //         {
                            //             replace: true
                            //         }
                            //     )
                            // }
                        >
                            Begin Training
                        </Button>
                        <Button
                            mb="5.5rem"
                            w="130px"
                            fontSize="16px"
                            fontWeight="400"
                            bg="black"
                            mx="auto"
                            borderRadius="48px"
                            color="white"
                            onClick={() =>
                                navigate(
                                    screen > 500
                                        ? '/dashboard/complete-training'
                                        : '/complete-training',
                                    {
                                        replace: true,
                                    },
                                )
                            }>
                            Skip{' '}
                        </Button>
                    </Flex>
                </Box>
            </Flex>
        </TrainingContainer>
    );
};

export default DesktopTraining;
